module.exports = __webpack_public_path__ + "static/media/technology-cover-Desktop.28bc5aeb.png";